import { Component, ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router';
import { AdminApi } from '../admin-api';
import Header from './Header';
import LoadingButton from './LoadingButton';
import PageLoading from './PageLoading';
import Sidebar from './Sidebar';

export default function ActivateGoogleCalendar(props: any): ReactNode {
  return (
    <ActivateGoogleCalendarComp
      navigate={useNavigate()}
      params={useParams()}
      {...props}
    />
  );
}

class ActivateGoogleCalendarComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
      params?: any;
    }>,
  ) {
    super(props);
    this.state = {
      isLoading: true,
      isConnecting: false,
      isConnected: false,
      expiresDate: '',
    };
  }

  async componentDidMount(): Promise<void> {
    this.setState({ isLoading: true });

    const _data = await AdminApi.get(`/current-user/google-calendar`);
    this.setState({ expiresDate: _data.expiresDate });

    this.setState({ isLoading: false });
  }

  async getLink() {
    this.setState({ isConnecting: true });

    const _data = await AdminApi.get(`/events/googleapi/auth/url`);
    window.open(_data, '_blank')!.focus();

    this.setState({ isConnecting: false, isConnected: true });
  }

  state: Readonly<{
    isLoading: boolean;
    isConnected: boolean;
    isConnecting: boolean;
    expiresDate: string;
  }>;

  render(): ReactNode {
    return this.state.isLoading ? (
      <PageLoading />
    ) : (
      <div>
        <Header
          navigate={this.props.navigate}
          currentUser={this.props.currentUser}
        ></Header>
        <div className="container-fluid">
          <div className="row">
            <Sidebar
              navigate={this.props.navigate}
              currentUser={this.props.currentUser}
            ></Sidebar>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">Conectar ao Google Agenda</h1>
              </div>
              <div className="mb-3">
                {this.state.expiresDate ? (
                  <p>Conexão expira em {this.state.expiresDate}</p>
                ) : (
                  <p>Conecte a Google Agenda</p>
                )}
              </div>
              <div className="mb-3">
                {this.state.isConnected ? (
                  <div className="alert alert-success">
                    Conectado com sucesso!
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => this.getLink()}
                    disabled={this.state.isConnecting}
                    className="btn btn-primary"
                  >
                    {this.state.isConnecting ? (
                      <LoadingButton />
                    ) : this.state.expiresDate ? (
                      'Refazer conexão'
                    ) : (
                      'Conectar'
                    )}
                  </button>
                )}
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
